import { useTranslation } from "react-i18next";
import Page from "components/page/Page";
import React, { useState } from "react";
import { useHistory } from "react-router";
import WebsiteBuilderTemplate, { IWebsiteBuilderTemplate } from "./WebsiteBuilderTemplate";

export default function WebsiteBuilderTemplatePreview() {
  const history = useHistory();
  const { t } = useTranslation();
  const [template] = useState<IWebsiteBuilderTemplate>({
    id: 1,
    src: "../../../public/images/websiteBuilder/configuration/templates/website_builder_traditional_template.png",
    title: "Traditional",
  });

  return (
    <Page
      narrow
      title={t("Traditional Preview")}
      subtitle={t("You can customize the layout, colours, fonts, or theme when editing.")}
      primaryAction={{
        content: t("Select template"),
        action: () => history.push("/admin/website-builder-editor"),
      }}
      breadcrumbs={[
        {
          prefix: true,
          label: t("Go back"),
          url: "/admin/website-builder/templates",
        },
      ]}
    >
      <WebsiteBuilderTemplate template={template} />
    </Page>
  );
}
